import { useEffect, useState } from "react";

import api from "../services/api";

import {
  Bar,
  Line
} from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

import * as XLSX from "xlsx";

import jsPDF from "jspdf";

import autoTable from "jspdf-autotable";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function RevenuePage() {

  const [dailyRevenue, setDailyRevenue] =
    useState([]);

  const [driversRevenue, setDriversRevenue] =
    useState([]);

  // 🚀 FETCH DATA
  const fetchData = async () => {

    try {

      const dayRes =
        await api.get("/revenue/day");

      const driverRes =
        await api.get("/revenue/drivers");

      setDailyRevenue(dayRes.data);

      setDriversRevenue(driverRes.data);

    } catch (err) {

      console.log(err);

    }
  };

  useEffect(() => {

    fetchData();

  }, []);

  // 📊 EXPORT EXCEL
  const exportExcel = () => {

    const worksheet =
      XLSX.utils.json_to_sheet(
        driversRevenue
      );

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Revenus"
    );

    XLSX.writeFile(
      workbook,
      "revenus_dieulsima.xlsx"
    );
  };

  // 📄 EXPORT PDF
  const exportPDF = () => {

    const doc = new jsPDF();

    doc.text(
      "Rapport Revenus Dieulsima",
      20,
      20
    );

    autoTable(doc, {

      startY: 40,

      head: [[
        "Chauffeur",
        "Revenu"
      ]],

      body: driversRevenue.map(
        (d) => [
          d.name,
          d.revenue + " FCFA"
        ]
      )
    });

    doc.save(
      "revenus_dieulsima.pdf"
    );
  };

  // 📈 DAILY CHART
  const dailyChartData = {

    labels: dailyRevenue.map(
      (d) => d.day
    ),

    datasets: [
      {
        label: "Revenus par jour",

        data: dailyRevenue.map(
          (d) => d.revenue
        ),

        backgroundColor: "#FFA500",

        borderColor: "#0B3C5D"
      }
    ]
  };

  // 🚗 DRIVER CHART
  const driverChartData = {

    labels: driversRevenue.map(
      (d) => d.name
    ),

    datasets: [
      {
        label:
          "Revenus par chauffeur",

        data: driversRevenue.map(
          (d) => d.revenue
        ),

        backgroundColor: "#0B3C5D"
      }
    ]
  };

  return (

    <div>

      {/* EXPORT BUTTONS */}
      <div
        style={{
          marginBottom: 20,
          display: "flex",
          gap: 15
        }}
      >

        <button
          onClick={exportExcel}
          style={excelBtn}
        >
          📊 Export Excel
        </button>

        <button
          onClick={exportPDF}
          style={pdfBtn}
        >
          📄 Export PDF
        </button>

      </div>

      <h1
        style={{
          color: "#0B3C5D",
          marginBottom: 30
        }}
      >
        💰 Analytics Revenus
      </h1>

      {/* DAILY */}
      <div style={card}>

        <h2 style={title}>
          📈 Revenus par jour
        </h2>

        <Line data={dailyChartData} />

      </div>

      {/* DRIVERS */}
      <div
        style={{
          ...card,
          marginTop: 30
        }}
      >

        <h2 style={title}>
          🚗 Revenus par chauffeur
        </h2>

        <Bar data={driverChartData} />

      </div>

    </div>
  );
}

const card = {

  background: "#fff",

  padding: 25,

  borderRadius: 15,

  boxShadow:
    "0 2px 10px rgba(0,0,0,0.08)"
};

const title = {

  color: "#0B3C5D",

  marginBottom: 20
};

const excelBtn = {

  background: "green",

  color: "#fff",

  border: "none",

  padding: "12px 18px",

  borderRadius: 8,

  cursor: "pointer",

  fontWeight: "bold"
};

const pdfBtn = {

  background: "#0B3C5D",

  color: "#fff",

  border: "none",

  padding: "12px 18px",

  borderRadius: 8,

  cursor: "pointer",

  fontWeight: "bold"
};